<template>
    <component :is="layout" v-bind="layoutProps" />
</template>

<script>
import MainLayout from '@/shared/main-layout';
import EmptyLayout from '@/shared/empty-layout';
import FaqLayout from '@/shared/faq-layout';
import MobileEmptyLayout from '@/shared/mobile-empty-layout';
import PTJEmptyLayout from '@/shared/ptj-empty-layout';
import MobileLayout from '@/shared/mobile-layout';
import PTJLayout from '@/shared/ptj-layout';
import { mapActions, mapState, mapMutations } from 'vuex';
import { triggerTimeoutNotification } from '@/utils/constants';
import helpers from '@/utils/helpers';

export default {
    name: 'App',
    components: { MainLayout, EmptyLayout, FaqLayout, MobileEmptyLayout, MobileLayout, PTJLayout, PTJEmptyLayout },
    data() {
        return {
            layout: null,
            layoutProps: {
                showHeader: true
            },
            tabFocus: false,
            intervalGetNotification: undefined
        };
    },
    created() {
        this.detectFocusOut();
        const path = window.location.pathname;
        if (helpers.version() != '1.5' && path.startsWith('/MNG_') && localStorage.getItem('token') && localStorage.getItem('userInfo')) {
            this.getDmTopCount();
        }
    },
    mounted() {},
    unmounted() {
        clearInterval(this.intervalGetNotification);
    },
    computed: {
        ...mapState('app', ['user', 'isLogin'])
    },
    watch: {
        $route(to) {
            if (!to.name.startsWith('App')) {
                //close modal back browser
                const popupClose = document.getElementsByClassName('btn-close');
                for (let i = 0; i <= popupClose.length; i++) {
                    popupClose[i]?.click();
                }
                setTimeout(() => {
                    const mail = document.getElementById('buttonClosePopupMail');
                    if (mail) {
                        mail.click();
                    }
                }, 200);
                const backdrop = document.getElementsByClassName('modal-backdrop fade show');
                if (backdrop && backdrop.length) {
                    backdrop[0]?.remove();
                }
            }

            if (to.meta.layout !== undefined) {
                this.layout = to.meta.layout;
            } else {
                this.layout = 'MainLayout'; // this is default layout if route meta is not set
            }

            this.layoutProps = {
                ...this.layoutProps,
                ...(to.meta.customeProps ? to.meta.customeProps : {})
            };

            // Check if current route path starts with /CUS_FAQ and update Vuex state
            const isHelpCenter = to.path.startsWith('/CUS_FAQ');
            this.setIsFaqLayout(isHelpCenter);
        },
        tabFocus(value) {
            if (value) {
                if (this.$route.name?.toUpperCase().includes('MNG')) {
                    localStorage.setItem('mode', 1);
                }
                if (this.$route.name?.toUpperCase().includes('CUS')) {
                    localStorage.setItem('mode', 2);
                }
            }
        },
        isLogin(value) {
            if (value) {
                this.intervalGetNotification = setInterval(() => {
                    this.getNotificationMessage();
                }, triggerTimeoutNotification * 1000);
            } else {
                clearInterval(this.intervalGetNotification);
            }
        }
    },
    methods: {
        ...mapActions('app', ['getS9007', 'getNotificationMessage', 'getDmTopCount']),
        ...mapMutations('app', ['setIsFaqLayout']),
        detectFocusOut() {
            let inView = false;
            window.onfocus =
                window.onblur =
                window.onpageshow =
                window.onpagehide =
                    (e) => {
                        if ({ focus: 1, pageshow: 1 }[e.type]) {
                            if (inView) return;
                            this.tabFocus = true;
                            inView = true;
                        } else if (inView) {
                            this.tabFocus = !this.tabFocus;
                            inView = false;
                        }
                    };
        }
    }
};
</script>

<style lang="scss">
@import 'bootstrap/scss/bootstrap.scss';
@import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
@import '@/assets/scss/common/common.scss';
@import '@/assets/scss/common/ptj-common.scss';
@import '@/assets/scss/common/basscss.min.scss';
</style>
